module.exports = "pegasus_template/assets/active-row-border-top.png";